export default [
  { label: "Zona 1", value: "Zona 1" },
  { label: "Zona 2", value: "Zona 2" },
  { label: "Zona 3", value: "Zona 3" },
  { label: "Zona 4", value: "Zona 4" },
  { label: "Zona 5", value: "Zona 5" },
  { label: "Zona 6", value: "Zona 6" },
  { label: "Zona 7", value: "Zona 7" },
  { label: "Zona 8", value: "Zona 8" },
  { label: "Zona 9", value: "Zona 9" },
  { label: "Zona 10", value: "Zona 10" },
  { label: "Zona 11", value: "Zona 11" },
  { label: "Zona 12", value: "Zona 12" },
  { label: "Zona 13", value: "Zona 13" },
  { label: "Zona 14", value: "Zona 14" },
  { label: "Zona 15", value: "Zona 15" },
  { label: "Zona 16", value: "Zona 16" },
  { label: "Zona 17", value: "Zona 17" },
  { label: "Zona 18", value: "Zona 18" },
  { label: "Zona 19", value: "Zona 19" },
  { label: "Zona 20", value: "Zona 20" },
  { label: "Zona 21", value: "Zona 21" },
  { label: "Zona 22", value: "Zona 22" },
  { label: "Zona 23", value: "Zona 23" },
  { label: "Zona 24", value: "Zona 24" },
  { label: "Zona 25", value: "Zona 25" },
];
